<template>
  <div class="has-fixed-page-subheader">
    <div class="page-subheader d-flex">
      <div class="page-subheader-content d-flex text-center align-self-center">
        <span class="  text-center align-self-center">
          {{ tt.getTranslatedText(activeLang, "orangeReport") }}
          <!-- View Orange Report -->
        </span>
        <router-link
          :to="
            permissions.crewLeaderDashboard &&
            permissions.crewLeaderDashboard.canAccess
              ? `/crewLeader/dashboard`
              : `/customers/${customerId}`
          "
          class="back-to-dashboard-link   text-center align-self-center"
        >
          {{ tt.getTranslatedText(activeLang, "backToDashboard") }}
          <!-- Back to Dashboard -->
        </router-link>
      </div>
    </div>
    <v-skeleton-loader class="mx-auto ml-2 mr-2" type="card" :loading="loading">
      <v-card elevation="0" class="border-0" outlined>
        <!-- <v-card-title class="orange-bg font-weight-bold white--text">
         
          <v-row>
            <v-col cols="12" md="3">
              <span class="font-weight-bold">Orange Report</span>
            </v-col>
            <v-col cols="12" md="3">
              Service Date: {{ formatDate(serviceDate) }}
            </v-col>
            <v-col cols="12" md="6" class="d-flex justify-end">
              <v-btn small @click="downloadPdf">
                Download pdf
              </v-btn>
              <v-btn class="mx-1" small @click="showDeleteReport = true">
                Delete
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title> -->
        <v-card-text>
          <!-- Start New Orange Reports section -->
          <v-container>
            <v-row class="mb-4">
              <v-col>
                <span class="text-orange text-h3 font-weight-bold">
                  {{ orangeReport.communityName }}
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="3">
                <v-label>
                  <span class="text-black font-weight-bold">
                    {{ tt.getTranslatedText(activeLang, "serviceDate") }}:
                    <!-- Service Date: -->
                  </span>
                </v-label>
                <div>
                  <span class="text-h5">{{ formatDate(serviceDate) }}</span>
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <v-label>
                  <span class="text-black font-weight-bold">
                    {{ tt.getTranslatedText(activeLang, "quarterlyPlan") }}:
                    <!-- Quarterly plan: -->
                  </span>
                </v-label>
                <v-progress-linear
                  color="orange"
                  :value="orangeReport.ninetyDayPlanProgress"
                  height="25"
                >
                  <template v-slot:default="{ value }">
                    <strong>{{ Math.ceil(value) }}%</strong>
                  </template>
                </v-progress-linear>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="collapsable-section">
                <span
                  class="text-h4 font-weight-bolder py-3 text-black"
                  @click="servicesExpanded = !servicesExpanded"
                >
                  {{ servicesExpanded ? "-" : "+" }}
                  {{ tt.getTranslatedText(activeLang, "servicesRendered") }}
                </span>
              </v-col>
            </v-row>
            <v-row v-if="servicesExpanded">
              <v-col cols="12">
                <v-card class="border-0 mt-0" elevation="0" outlined>
                  <v-card-text>
                    <v-row>
                      <v-col
                        cols="6"
                        sm="4"
                        md="3"
                        v-for="(service, i) in renderedServices"
                        :key="'service_col_' + i"
                      >
                        <v-checkbox
                          readonly
                          color="orange"
                          v-model="renderedServices"
                          :label="service"
                          :value="service"
                          class="v-checkbox-no-margin mt-0"
                          solo
                          hide-details
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                    <v-row class="mt-2">
                      <v-col>
                        <v-label>
                          <span class="text-black font-weight-bold">
                            {{
                              tt.getTranslatedText(activeLang, "visitNotes")
                            }}:
                          </span>
                        </v-label>
                        <v-textarea v-model="visitNotes" solo readonly>
                        </v-textarea>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="collapsable-section">
                <span
                  class="text-h4 font-weight-bolder py-3 text-black"
                  @click="imagesExpanded = !imagesExpanded"
                >
                  {{ imagesExpanded ? "-" : "+" }}
                  {{ tt.getTranslatedText(activeLang, "images") }}
                </span>
              </v-col>
            </v-row>
            <v-row v-if="imagesExpanded">
              <v-col cols="12">
                <v-card class="border-0 mt-0" elevation="0" outlined>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12">
                        <v-label>
                          <span class="text-black font-weight-bold">
                            {{
                              tt.getTranslatedText(activeLang, "addImages") +
                                "(" +
                                tt.getTranslatedText(activeLang, "upTo") +
                                " " +
                                maxFilesCount +
                                ")"
                            }}:
                          </span>
                        </v-label>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        v-for="(item, i) in orangeReport.photos.$values"
                        cols="12"
                        md="3"
                        sm="4"
                        xs="6"
                        class="darggable-col"
                        :key="'o' + i"
                      >
                        <div>
                          <a
                            href="#"
                            @click.prevent="showViewImageDialog(item)"
                            class="canEnlargeImage"
                          >
                            <v-img :src="item.fileUrl"></v-img>
                          </a>

                          <span>{{ item.description }}</span>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="collapsable-section">
                <span
                  class="text-h4 font-weight-bolder py-3 text-black"
                  @click="
                    followUpAndActionItemsExpanded = !followUpAndActionItemsExpanded
                  "
                >
                  {{ followUpAndActionItemsExpanded ? "-" : "+" }}
                  {{
                    tt.getTranslatedText(activeLang, "followUpAndActionItems")
                  }}
                </span>
              </v-col>
            </v-row>

            <v-row v-if="followUpAndActionItemsExpanded">
              <v-col cols="12">
                <v-card class="border-0 mt-0" elevation="0" outlined>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12">
                        <v-textarea
                          readonly
                          v-model="followUpActions"
                          solo
                        ></v-textarea>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>

            <!-- <v-row>
              <v-col cols="12" md="9">
                <v-container>
                  <h6 class="font-weight-bold">Services Rendered</h6>
                  <v-row>
                    <v-col
                      cols="6"
                      sm="4"
                      md="3"
                      v-for="(service, i) in dbOrangeReportServices"
                      :key="'service_col_' + i"
                    >
                      <v-checkbox
                        readonly
                        v-model="renderedServices"
                        :label="getServiceName(service)"
                        :value="service.name"
                        color="blue"
                        class="v-checkbox-no-margin"
                      ></v-checkbox>
                    </v-col>
                  </v-row>
                  <hr />
                  <v-row>
                    <v-col>
                      <h6 class="font-weight-bold">Visit Notes</h6>
                      <v-textarea
                        readonly
                        v-model="orangeReport.visitNotes"
                        solo
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <hr />
                  <v-row>
                    <v-col>
                      <v-row>
                        <v-col class="d-flex justify-start align-center"
                          ><h6 class="font-weight-bold">
                            Irrigation Systems Health
                          </h6>
                          <div class="ml-5">
                            <v-img
                              width="40"
                              height="40"
                              contain
                              :src="irrigationSystemHealthInfo.picture"
                            ></v-img>
                          </div>
                          <span class="ml-4">{{
                            irrigationSystemHealthInfo.name
                          }}</span>
                        </v-col>
                      </v-row>
                      <v-row v-if="formattedIrrigationInspectionDate">
                        <v-col
                          >Your irrigation inspection is scheduled for
                          {{ formattedIrrigationInspectionDate }}</v-col
                        >
                      </v-row>
                    </v-col>
                  </v-row>
                  <hr />
                  <v-row>
                    <v-col>
                      <h6 class="font-weight-bold">
                        Resident Notepad
                      </h6>
                      <v-textarea
                        readonly
                        v-model="orangeReport.residentNotepad"
                        solo
                      ></v-textarea>
                    </v-col>
                  </v-row>
                  <hr />
                  <v-row>
                    <v-col>
                      <h6 class="font-weight-bold">
                        Quarterly Community Enhancement Plan
                      </h6>
                      <v-progress-linear
                        readonly
                        color="blue"
                        :value="orangeReport.ninetyDayPlanProgress"
                        height="25"
                      >
                        <template v-slot:default="{ value }">
                          <strong>{{ Math.ceil(value) }}%</strong>
                        </template></v-progress-linear
                      >
                      <v-row class="pt-2">
                        <v-col>
                          <span class="v-label theme--light"
                            >Quarterly Orange Walk
                            {{
                              quarterlyOrangeWalkDate
                                ? " is scheduled for " +
                                  formattedQuarterlyOrangeWalkDate
                                : " is not scheduled"
                            }}</span
                          ></v-col
                        >
                      </v-row>
                    </v-col>
                  </v-row>
                  <hr />
                  <v-row>
                    <v-col>
                      <h6 class="font-weight-bold">
                        Follow Up / Actions*
                      </h6>
                      <v-textarea
                        readonly
                        v-model="orangeReport.followUpActions"
                        solo
                      ></v-textarea>
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
              <v-col cols="12" md="3">
                <v-container>
                  <v-row>
                    <v-col class="px-4 pb-n4" cols="12">
                      <span class="text-h6 theme--light font-weight-bold"
                        >Photos</span
                      >
                      <v-row>
                        <v-col
                          cols="12"
                          v-for="(item, i) in orangeReport.photos.$values"
                          :key="'o' + i"
                        >
                          <div>
                            <a
                              href="#"
                              @click.prevent="showViewImageDialog(item)"
                              class="canEnlargeImage"
                            >
                              <v-img :src="item.fileUrl"></v-img>
                            </a>

                            <span>{{ item.description }}</span>
                          </div>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-col>
            </v-row> -->
          </v-container>
          <!-- End Recent Orange Reports section -->
        </v-card-text>
        <v-card-actions>
          <v-row>
            <v-col cols="12" class="text-right">
              <router-link
                class="text-green mx-1"
                :to="`/customers/${customerId}`"
              >
                {{ tt.getTranslatedText(activeLang, "cancel") }}
              </router-link>
              <router-link
                class="text-green mx-1"
                :to="`/customers/${customerId}/orange-reports/${reportId}/edit`"
              >
                {{ tt.getTranslatedText(activeLang, "edit") }}
              </router-link>
              <v-btn
                class="text-white background-color-green mx-1"
                @click="downloadPdf"
              >
                Download pdf
              </v-btn>
              <v-btn
                v-if="
                  permissions.orangeReport && permissions.orangeReport.canDelete
                "
                class="text-white background-color-green mx-1"
                @click="showDeleteReport = true"
              >
                Delete
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
      <v-dialog
        v-model="showImageDialog"
        fullscreen
        transition="dialog-bottom-transition"
      >
        <v-card tile>
          <v-toolbar flat dark class="orange-bg">
            <v-spacer></v-spacer>
            <v-btn icon dark @click="showImageDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-responsive :aspect-ratio="16 / 9">
            <v-card-text>
              <v-img
                :id="'preview_img_' + itemToView.id"
                aspect-ratio="1.7"
                min-height="600"
                contain
                position="center center"
                :src="itemToView.fileUrl"
              >
                <template v-slot:placeholder>
                  <v-row
                    class="fill-height ma-0"
                    center="center"
                    justify="center"
                  >
                    <v-progress-circular
                      indeterminate
                      color="grey lighten-5"
                    ></v-progress-circular>
                  </v-row>
                </template>
              </v-img>
              <span>{{ itemToView.description }}</span>
            </v-card-text>
          </v-responsive>

          <div style="flex: 1 1 auto;"></div>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showDeleteReport" persistent max-width="290">
        <v-card>
          <v-card-title></v-card-title>
          <v-card-text>
            Are you sure you want to delete the report?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              v-if="!statusProcessing"
              color="green darken-1"
              text
              @click="showDeleteReport = false"
            >
              Cancel
            </v-btn>
            <v-btn
              color="green darken-1"
              text
              @click="deleteReport()"
              :loading="statusProcessing"
            >
              Confirm
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- </v-container> -->
    </v-skeleton-loader>
  </div>
</template>

<script>
// import CommunityInfo from "@/view/components/CommunityInfo.vue";
// import InternalBreadcrumbs from "@/view/components/DashboardInternalBreadcrumbs.vue";
import {
  DELETE,
  GET_QUERY,
  API_CUSTOMERS,
  API_ORANGE_REPORTS,
  API_ORANGE_REPORT_SERVICES
} from "@/core/store/crud.module";
import crud from "@/core/helpers/crud";

// import { API_USERS } from "@/core/store/crud.module";
// import dateFormatter from "@/core/helpers/dateFormatter";
import stringFormatter from "@/core/helpers/stringFormatter";
import { validationMixin } from "vuelidate";

// import pdfmake from "pdfmake/build/pdfmake.js";

// import { required } from "vuelidate/lib/validators";
// import moment from "moment";
import translatedText from "@/core/helpers/translatedText.js";
import i18nService from "@/core/services/i18n.service.js";
import permissionsHelper from "@/core/helpers/permissionsHelper";

export default {
  mixins: [validationMixin],
  components: {
    // CommunityInfo,
    // InternalBreadcrumbs
  },
  data: () => ({
    tt: {},
    servicesExpanded: true,
    imagesExpanded: true,
    followUpAndActionItemsExpanded: true,
    communityInfo: {},
    relatedCommunity: null,
    relatedCommunityItems: [],
    serviceDate: null,
    formattedServiceDate: null,
    irrigationInspectionDate: null,
    formattedIrrigationInspectionDate: null,
    quarterlyOrangeWalkDate: null,
    formattedQuarterlyOrangeWalkDate: null,
    irrigationSystemStatusList: [
      "AllGoWithTheFlow",
      "NeedsAttention",
      "UnderRepair"
    ],
    orangeReport: {
      id: "",
      name: "",
      dateCreated: null,
      serviceDate: null,
      formattedServiceDate: null,
      visitNotes: "",
      photos: [],
      irrigationSystemInspectionDate: null,
      irrigationSystemStatus: "AllGoWithTheFlow",
      residentNotepad: "",
      ninetyDayPlanProgress: 0,
      ninetyDayPlanTrack: true,
      quarterlyOrangeWalkDate: null,
      followUpActions: ""
    },

    visitNotes: "",
    residentNotepad: "",
    followUpActions: "",

    options: {
      page: 1,
      itemsPerPage: 5
    },
    pageText: "",
    hasMore: false,
    isLoading: false,
    loading: false,
    snackbarContent: "",
    snackbarColor: "#F06835",
    breadcrumbs: [],
    photosObj: [{ id: 1, url: null }],
    isFileUploading: false,
    videoExtensions: "mp4,mov,avi,mkv,mpg,vob,wmv,m4v,asf,srt",
    dbOrangeReportServices: [],
    renderedServices: [],
    orangeReportLoading: false,
    orangeReportServicesLoading: false,
    baseUrl: `${process.env.VUE_APP_DASHBOARD_URL}`,
    showDeleteReport: false,
    statusProcessing: false,
    itemToView: {},
    showImageDialog: false,
    maxFilesCount: 8,
    ninetyDayPlanProgress: 0,
    permissions: {}
  }),
  props: {
    customerId: {
      type: [Number, String],
      default: 0
    },
    reportId: {
      type: [Number, String],
      default: 0
    }
  },
  validations() {
    return true;
    // return {
    //   billingInfo: {
    //     subscription: {
    //       nextBillingDates: {
    //         required,
    //         minDate: value =>
    //           dateFormatter.convertToMilliseconds(value) >
    //           dateFormatter.convertToMilliseconds(new Date())
    //       }
    //     }
    //   }
    // };
  },
  watch: {
    serviceDate: function() {
      this.formattedServiceDate = this.formatDate(this.serviceDate);
    },
    irrigationInspectionDate: function() {
      if (this.irrigationInspectionDate) {
        this.formattedIrrigationInspectionDate = this.formatDate(
          this.irrigationInspectionDate
        );
      }
    },
    quarterlyOrangeWalkDate: function() {
      this.formattedQuarterlyOrangeWalkDate = this.formatDate(
        this.quarterlyOrangeWalkDate
      );
    }
  },
  async mounted() {
    this.loading = true;
    await this.getComunityInfo();
    // await this.createBreadcrumb();
    // await this.setInternalBreadcrumbs();
    await this.getOrangeReport();
    this.loading = false;
    // await this.getOrangeReportServices();
  },
  async created() {
    this.tt = translatedText;
    // await this.getComunityInfo();
    this.permissions = await permissionsHelper.getPermissions();
  },
  methods: {
    getServiceName(service) {
      if (!service) return "";
      if (this.activeLang == "es") return service.nameSpanish;
      return service.name;
    },
    showViewImageDialog(item) {
      this.itemToView = item;
      this.showImageDialog = true;
    },
    async deleteReport() {
      this.statusProcessing = true;

      let self = this;
      let url = `${API_ORANGE_REPORTS}`;
      self.$store
        .dispatch(DELETE, {
          listName: url,
          id: self.reportId
        })
        .then(response => {
          if (response.status >= 200 && response.status <= 204) {
            self.snackbarContent = "Report has been deleted";
            self.showDeleteReport = false;
            self.$snackbar.showMessage({
              content: self.snackbarContent,
              color: self.snackbarColor
            });

            self.$router.push({
              name: "OrangeReports",
              params: { customerId: self.customerId }
            });
          } else {
            self.snackbarContent = response.data;
            self.snackbarColor = "red";
          }

          self.showDeleteReport = false;
          self.statusProcessing = false;

          self.$snackbar.showMessage({
            content: self.snackbarContent,
            color: self.snackbarColor
          });
        });
    },
    initials() {
      return stringFormatter.initials(
        this.communityInfo.propertyManager.firstName,
        this.communityInfo.propertyManager.lastName
      );
    },

    serviceStatusPromise() {
      return this.$store.dispatch(GET_QUERY, {
        listName: `${API_CUSTOMERS}/${this.communityInfo.aspireId}/serviceStatus`
      });
    },
    urlToBase64(url) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.src = url;
        img.onload = () => {
          const canvas = document.createElement("canvas"),
            ctx = canvas.getContext("2d");
          canvas.height = img.height;
          canvas.width = img.width;
          ctx.drawImage(img, 0, 0);
          resolve(canvas.toDataURL("image/jpeg"));
        };
        img.onerror = error => reject(error);
      });
    },
    downloadPdf() {
      let pdfMake = require("pdfmake/build/pdfmake.js");
      if (pdfMake.vfs == undefined) {
        var pdfFonts = require("pdfmake/build/vfs_fonts.js");
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }

      let self = this;

      pdfMake.fonts = {
        Fontello: {
          normal: self.baseUrl + "/media/fontello-bcdeccb8/font/fontello.ttf",
          bold: self.baseUrl + "/media/fontello-bcdeccb8/font/fontello.ttf",
          italics: self.baseUrl + "/media/fontello-bcdeccb8/font/fontello.ttf",
          bolditalics:
            self.baseUrl + "/media/fontello-bcdeccb8/font/fontello.ttf"
        },

        //download default Roboto font from cdnjs.com
        Roboto: {
          normal:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf",
          bold:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf",
          italics:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf",
          bolditalics:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf"
        }

        // example of usage fonts in collection
        // PingFangSC: {
        //   normal: ['https://example.com/fonts/pingfang.ttc', 'PingFangSC-Regular'],
        //   bold: ['https://example.com/fonts/pingfang.ttc', 'PingFangSC-Semibold'],
        // }
      };

      let reportYear = new Date(this.orangeReport.serviceDate).getFullYear();
      let reportMonth = new Date(
        this.orangeReport.serviceDate
      ).toLocaleString("en-us", { month: "long" });

      let serviceDateModified = new Date(self.orangeReport.serviceDate)
        .toISOString()
        .substr(0, 10);

      const [, , day] = serviceDateModified.split("-");

      // let reportDay = new Date(
      //   this.orangeReport.serviceDate
      // ).toLocaleString("en-us", { day: "numeric" });

      let reportDay = day;

      let servicesRendered = this.orangeReport.servicesRendered.$values.map(
        item => item.name
      );

      // console.log(servicesRendered);

      let promisses = this.orangeReport.photos.$values.map(photo => {
        return this.urlToBase64(photo.fileUrl);
      });

      promisses.push(this.serviceStatusPromise());

      //  => icon-dot-circled
      const iconDotCircled = "";
      //  => icon-empty-circle
      // const iconEmptyCircle = "";

      Promise.allSettled(promisses).then(function(res) {
        // let newArray = res;
        let length = res.length;

        let serviceStatus = res[length - 1].value.data;

        res.splice(length - 1, 1);
        let reportImages = res.map(res => {
          return {
            image: res.value, //this.dataUrl,//"sidebar", //photo.fileUrl,
            style: "photos",
            width: 100
            // height: 60
          };
        });

        let imagesTableData = [];
        let imagesColumns = [];
        for (let i = 0; i < reportImages.length; i++) {
          imagesColumns.push(reportImages[i]);

          if (imagesColumns.length == 4) {
            imagesTableData.push(imagesColumns.slice());
            imagesColumns = [];
          }
        }

        if (imagesColumns.length < 4) {
          let missingColumns = 4 - imagesColumns.length;
          for (let i = 0; i < missingColumns; i++) {
            imagesColumns.push({ text: " " });
          }
          imagesTableData.push(imagesColumns.slice());
        }

        // [
        //               // border
        //               {
        //                 table: {
        //                   widths: ["*"],
        //                   body: [
        //                     [
        //                       {
        //                         text: "",
        //                         border: [false, false, false, true],
        //                         borderColor: [
        //                           "#E06521",
        //                           "#E06521",
        //                           "#E06521",
        //                           "#E06521"
        //                         ]
        //                       }
        //                     ]
        //                   ]
        //                 }
        //               },
        //

        //             ]

        let servicesTableData = [];
        let servicesColumns = [];
        for (let i = 0; i < servicesRendered.length; i++) {
          servicesColumns.push({
            text: [
              {
                text: iconDotCircled,
                style: "icon"
              },
              " " + servicesRendered[i]
            ]
          });

          if (servicesColumns.length == 4) {
            servicesTableData.push(servicesColumns.slice());
            servicesColumns = [];
          }
        }

        if (servicesColumns.length < 4) {
          let missingColumns = 4 - servicesColumns.length;
          for (let i = 0; i < missingColumns; i++) {
            servicesColumns.push({ text: " " });
          }
          servicesTableData.push(servicesColumns.slice());
        }

        let docDefinition = {
          images: {
            ynLogo: self.baseUrl + "/media/logos/logo-light.png",
            sidebar: self.baseUrl + "/media/assets/aside-bg.jpg",
            "sentiment-0.0":
              self.baseUrl + "/media/assets/orange-report/Leaf_0.0.png",
            "sentiment-0.5":
              self.baseUrl + "/media/assets/orange-report/Leaf_0.5.png",
            "sentiment-1.0":
              self.baseUrl + "/media/assets/orange-report/Leaf_1.0.png",
            "sentiment-1.5":
              self.baseUrl + "/media/assets/orange-report/Leaf_1.5.png",
            "sentiment-2.0":
              self.baseUrl + "/media/assets/orange-report/Leaf_2.0.png",
            "sentiment-2.5":
              self.baseUrl + "/media/assets/orange-report/Leaf_2.5.png",
            "sentiment-3.0":
              self.baseUrl + "/media/assets/orange-report/Leaf_3.0.png",
            "sentiment-3.5":
              self.baseUrl + "/media/assets/orange-report/Leaf_3.5.png",
            "sentiment-4.0":
              self.baseUrl + "/media/assets/orange-report/Leaf_4.0.png",
            "sentiment-4.5":
              self.baseUrl + "/media/assets/orange-report/Leaf_4.5.png",
            "sentiment-5.0":
              self.baseUrl + "/media/assets/orange-report/Leaf_5.0.png"
          },
          pageSize: "LETTER",
          pageMargins: [170, 40, 40, 40],
          background: function(currentPage, pageSize) {
            return [
              {
                canvas: [
                  {
                    type: "rect",
                    x: 0,
                    y: 0,
                    w: 150,
                    h: pageSize.height / 5,
                    color: "#E06521"
                  },
                  {
                    type: "rect",
                    x: 0,
                    y: pageSize.height / 5,
                    w: 150,
                    h: 5,
                    color: "#2DC1E4"
                  }
                ]
              },
              {
                image: "ynLogo",
                width: 120,
                absolutePosition: { x: 10, y: 15 }
              },
              {
                text: "ORANGE",
                absolutePosition: { x: 25, y: 67 },
                color: "white",
                fontSize: 20,
                bold: true,
                characterSpacing: -0.5
              },
              {
                text: "REPORT",
                absolutePosition: { x: 25, y: 85 },
                color: "black",
                fontSize: 20,
                bold: true,
                characterSpacing: 0.5
              },
              {
                text: `${reportMonth} ${reportDay}`,
                absolutePosition: { x: 25, y: 112 },
                color: "white",
                fontSize: 20,
                bold: true
              },
              {
                text: `${reportYear}`,
                absolutePosition: { x: 25, y: 130 },
                color: "black",
                fontSize: 20,
                bold: true
              },
              {
                image: "sidebar",
                width: 150,
                height: pageSize.height * (4 / 5) - 5
              }
            ];
          },
          content: [
            {
              columns: [
                {
                  // auto-sized columns have their widths based on their content
                  width: "auto",
                  text: "" //this.initials()
                },
                {
                  // star-sized columns fill the remaining space
                  // if there's more than one star-column, available width is divided equally
                  width: "*",
                  text: self.orangeReport.communityName.toUpperCase(),
                  fontSize: 15,
                  bold: true,
                  color: "#df6526"
                }
              ]
            },
            "\n\n",
            {
              columns: [
                {
                  // fixed width
                  width: "auto",
                  text: [
                    {
                      text:
                        self.communityInfo.propertyManager.fullName +
                        ", " +
                        self.communityInfo.propertyManager.role,
                      margin: 20
                    },
                    { text: "\n" + self.communityInfo.propertyManager.phone },
                    { text: " \n\nManaged by:\n", bold: true },
                    { text: self.communityInfo.managementCompany.name + "\n" },
                    {
                      text:
                        self.communityInfo.managementCompany.address.line1 +
                        "\n"
                    },
                    {
                      text:
                        self.communityInfo.managementCompany.address.city +
                        ",  " +
                        self.communityInfo.managementCompany.address.stateCode +
                        " " +
                        self.communityInfo.managementCompany.address.postalCode
                    }
                  ]
                },
                {
                  // percentage width
                  width: "*",
                  stack: [
                    {
                      text: "Community Landscape Quality Sentiment",
                      bold: true
                    },
                    {
                      image:
                        "sentiment-" +
                        new Number(self.communityInfo.sentiment.value).toFixed(
                          1
                        ),
                      width: 120,
                      style: "my5"
                    },
                    {
                      text: self.communityInfo.sentiment.value + " / 5",
                      bold: true,
                      fontSize: 15
                    }
                  ],
                  alignment: "center"
                },
                {
                  // percentage width
                  width: "auto",
                  text: [
                    { text: "Service Status", bold: true },
                    "\n\n" + serviceStatus.status
                  ],
                  alignment: "center"
                }
              ],
              columnGap: 10
            },
            "\n\n",
            // plan progress
            {
              columns: [
                {
                  width: "auto",
                  stack: [
                    {
                      text: "Quarterly Plan",
                      style: "heading"
                    },
                    {
                      stack: [
                        {
                          canvas: [
                            {
                              type: "rect",
                              x: 0,
                              y: 0,
                              w: 280,
                              h: 15,
                              color: "#E7E7E8" // light gray
                            },
                            {
                              type: "rect",
                              x: 0,
                              y: 0,
                              w:
                                280 *
                                (self.orangeReport.ninetyDayPlanProgress / 100),
                              h: 15,
                              color: "#df6526" //"#97B73D" // green
                            }
                          ]
                        },
                        {
                          stack: [
                            {
                              text:
                                self.orangeReport.ninetyDayPlanProgress + "%",
                              style: { bold: true },
                              relativePosition: { x: 140, y: -12 }
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }

                // {
                //   // auto-sized columns have their widths based on their content
                //   width: "auto",
                //   stack: [
                //     {
                //       text: "Service Requests This Period",
                //       bold: true,
                //       style: "mb5"
                //     },
                //     {
                //       columns: [
                //         {
                //           width: "*",
                //           stack: [
                //             { text: "5", fontSize: 16, bold: true },
                //             "Open Tasks"
                //           ],
                //           alignment: "center"
                //         },
                //         {
                //           width: "*",
                //           stack: [
                //             { text: "2", fontSize: 16, bold: true },
                //             "Closed"
                //           ],
                //           alignment: "center"
                //         }
                //       ]
                //     }
                //   ]
                // },
                // {
                //   // star-sized columns fill the remaining space
                //   // if there's more than one star-column, available width is divided equally
                //   width: "*",
                //   text: [
                //     {
                //       text:
                //         "Quarterly Orange Walk  " +
                //         (self.quarterlyOrangeWalkDate
                //           ? " is scheduled for " +
                //             self.formattedQuarterlyOrangeWalkDate
                //           : " is not sheduled"),
                //       alignment: "center"
                //     }
                //   ]
                // }
              ],
              // optional space between columns
              columnGap: 10
            },
            "\n\n",
            // branch office and account manager info start section
            {
              table: {
                widths: ["*"],
                body: [
                  [
                    {
                      text: "",
                      border: [false, true, false, false],
                      borderColor: ["#E06521", "#E06521", "#E06521", "#E06521"]
                    }
                  ]
                ]
              },
              style: "mt5"
            },
            // branch office and account manager info
            {
              layout: "noBorders",
              table: {
                widths: ["*", "*"],
                body: [
                  [
                    {
                      text: [
                        { text: "Branch Office: ", bold: true },
                        self.communityInfo.branch.name
                      ]
                    },
                    {
                      text: [
                        { text: "Account Manager: ", bold: true },
                        self.communityInfo.accountManager.fullName
                      ]
                    }
                  ]
                ]
              }
            },
            // border
            {
              table: {
                widths: ["*"],
                body: [
                  [
                    {
                      text: "",
                      border: [false, false, false, true],
                      borderColor: ["#E06521", "#E06521", "#E06521", "#E06521"]
                    }
                  ]
                ]
              },
              style: "mb10"
            },

            {
              layout: "noBorders",
              table: {
                widths: ["*"], //widths: ["*", 100],
                body: [
                  // body open
                  [
                    // first row open
                    [
                      // first column open
                      {
                        text: "Services Rendered",
                        style: "heading"
                      },

                      // services rendered
                      {
                        table: {
                          body: servicesTableData
                        },
                        layout: "noBorders"
                      },
                      // visit notes
                      { text: "\n\nVisit Notes", style: "heading" },
                      { text: self.orangeReport.visitNotes }
                    ] // first column close
                  ], // first row close
                  [
                    [
                      // border
                      {
                        table: {
                          widths: ["*"],
                          body: [
                            [
                              {
                                text: "",
                                border: [false, false, false, true],
                                borderColor: [
                                  "#E06521",
                                  "#E06521",
                                  "#E06521",
                                  "#E06521"
                                ]
                              }
                            ]
                          ]
                        }
                      },
                      { text: "Images", style: "heading" },
                      // border
                      {
                        table: {
                          widths: ["*"],
                          body: [
                            [
                              {
                                text: "",
                                border: [false, true, false, false],
                                borderColor: [
                                  "#E06521",
                                  "#E06521",
                                  "#E06521",
                                  "#E06521"
                                ]
                              }
                            ]
                          ]
                        }
                        //style: "mb10"
                      }
                    ]
                  ],
                  [
                    // second row open
                    // images
                    [
                      {
                        table: {
                          body: imagesTableData
                        },
                        layout: "noBorders"
                      }
                    ]
                    // reportImages
                  ], // second row close
                  [
                    [
                      // border
                      {
                        table: {
                          widths: ["*"],
                          body: [
                            [
                              {
                                text: "",
                                border: [false, false, false, true],
                                borderColor: [
                                  "#E06521",
                                  "#E06521",
                                  "#E06521",
                                  "#E06521"
                                ]
                              }
                            ]
                          ]
                        }
                      },
                      { text: "Follow Up / Actions", style: "heading" },
                      // border
                      {
                        table: {
                          widths: ["*"],
                          body: [
                            [
                              {
                                text: "",
                                border: [false, true, false, false],
                                borderColor: [
                                  "#E06521",
                                  "#E06521",
                                  "#E06521",
                                  "#E06521"
                                ]
                              }
                            ]
                          ]
                        }
                        //style: "mb10"
                      },
                      { text: self.orangeReport.followUpActions }
                    ]
                  ]
                ] // body close
              }
            }
          ],
          defaultStyle: {
            fontSize: 8,
            bold: false
          },
          styles: {
            heading: {
              color: "#000000", // "#E06521",
              bold: true,
              margin: [0, 5, 0, 5]
            },
            icon: { font: "Fontello" },
            photos: {
              margin: [0, 10, 0, 10]
            },
            mt5: { margin: [0, 5, 0, 0] },
            mt10: { margin: [0, 10, 0, 0] },
            mb5: { margin: [0, 0, 0, 5] },
            mb10: { margin: [0, 0, 0, 10] },
            my5: { margin: [0, 5, 0, 5] },
            my10: { margin: [0, 10, 0, 10] }
          }
        };
        pdfMake.createPdf(docDefinition).open();
      });
    },
    showRelatedCommunity(communityId) {
      this.$router.push({
        name: "CustomerDetails",
        params: { customerId: communityId }
      });
    },
    async getComunityInfo() {
      this.loading = true;

      await this.$store
        .dispatch(GET_QUERY, {
          listName: API_CUSTOMERS,
          id: this.customerId
        })
        .then(response => {
          if (response.status >= 200 || response.status <= 204) {
            this.communityInfo = crud.getPopulatedComunityInfo(response.data);
            // this.getOrangeReport();
          } else {
            this.$snackbar.showMessage({
              content: response.data || "Something went wrong!",
              color: "red"
            });
          }

          this.loading = false;
        });
    },
    async getOrangeReportServices() {
      this.orangeReportServicesLoading = true;

      await this.$store
        .dispatch(GET_QUERY, {
          listName: API_ORANGE_REPORT_SERVICES
        })
        .then(response => {
          if (response.status >= 200 || response.status <= 204) {
            this.dbOrangeReportServices = response.data.$values;
            // this.renderedServices = this.dbOrangeReportServices.map(
            //   o => o.name
            // );
          } else {
            this.$snackbar.showMessage({
              content: response.data || "Something went wrong!",
              color: "red"
            });
          }

          this.orangeReportServicesLoading = false;
        });
    },
    // async setInternalBreadcrumbs() {
    //   this.breadcrumbs = [
    //     {
    //       title: this.communityInfo.name,
    //       route: "/customers/" + this.customerId
    //     },
    //     {
    //       title: "Orange Reports",
    //       route: "/customers/" + this.customerId + "/orange-reports"
    //     },
    //     { title: "View Orange Report" }
    //   ];
    // },
    approveOrangeReport() {
      this.orangeReport.status = "approved";
      this.saveOrangeReport();
    },
    async getOrangeReport() {
      this.orangeReportLoading = true;
      await this.$store
        .dispatch(GET_QUERY, {
          listName: API_ORANGE_REPORTS,
          id: this.reportId
        })
        .then(response => {
          if (response.status >= 200 || response.status <= 204) {
            this.orangeReport = response.data;

            this.visitNotes =
              this.activeLang == "es"
                ? this.orangeReport.visitNotesSpanish
                  ? this.orangeReport.visitNotesSpanish
                  : this.orangeReport.visitNotes
                : this.orangeReport.visitNotes;
            this.residentNotepad =
              this.activeLang == "es"
                ? this.orangeReport.residentNotepadSpanish
                  ? this.orangeReport.residentNotepadSpanish
                  : this.orangeReport.residentNotepad
                : this.orangeReport.residentNotepad;
            this.followUpActions =
              this.activeLang == "es"
                ? this.orangeReport.followUpActionsSpanish
                  ? this.orangeReport.followUpActionsSpanish
                  : this.orangeReport.followUpActions
                : this.orangeReport.followUpActions;

            // this.orangeReport.photos.$values.forEach(el => {
            //   el.viewImageDialog = false;
            // });

            this.renderedServices = this.orangeReport.servicesRendered.$values.map(
              s => s.name
            );

            this.serviceDate = new Date(this.orangeReport.serviceDate)
              .toISOString()
              .substr(0, 10);
            if (this.orangeReport.orangeWalkDate) {
              this.quarterlyOrangeWalkDate = new Date(
                this.orangeReport.orangeWalkDate
              )
                .toISOString()
                .substr(0, 10);
              this.formattedQuarterlyOrangeWalkDate = this.formatDate(
                this.quarterlyOrangeWalkDate
              );
            } else {
              this.quarterlyOrangeWalkDate = null;
              this.formattedQuarterlyOrangeWalkDate = null;
            }
            this.irrigationInspectionDate = null;
            if (this.orangeReport.irrigationInspectionDate) {
              this.irrigationInspectionDate = new Date(
                this.orangeReport.irrigationInspectionDate
              )
                .toISOString()
                .substr(0, 10);
            }
            this.formattedIrrigationInspectionDate = null;
            if (this.irrigationInspectionDate) {
              this.formattedIrrigationInspectionDate = this.formatDate(
                this.irrigationInspectionDate
              );
            }
          } else {
            this.$snackbar.showMessage({
              content: response.data || "Something went wrong!",
              color: "red"
            });
          }

          this.orangeReportLoading = false;
        });
    },
    // createBreadcrumb() {
    //   this.$store.dispatch(SET_BREADCRUMB, [
    //     { title: "Customers", route: "/customers" },
    //     {
    //       title: this.communityInfo.name,
    //       route: "/customers/" + this.customerId
    //     },
    //     {
    //       title: "Orange Reports",
    //       route: "/customers/" + this.customerId + "/orange-reports"
    //     },
    //     { title: "View Orange Report" }
    //   ]);
    // },
    // async submit() {
    //   this.$v.$touch();
    //   if (this.$v.$invalid) {
    //     return;
    //   }
    // },
    capitalizeFirstLetter(string) {
      return stringFormatter.capitalizeFirstLetter(string);
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
  },
  computed: {
    irrigationSystemHealthInfo() {
      switch (this.orangeReport.irrigationSystemHealth) {
        case 0: //All Go With The Flow
          return {
            name: "All Go With The Flow",
            picture:
              "/media/assets/irrigation-system-health/icons-all-go-with-the-flow.png"
          };
        case 1: //Needs Attention
          return {
            name: "Needs Attention",
            picture:
              "/media/assets/irrigation-system-health/icons-needs-attention.png"
          };
        case 2: //Under Repair
          return {
            name: "Under Repair",
            picture:
              "/media/assets/irrigation-system-health/icons-under-repair.png"
          };

        default:
          return {
            name: "All Go With The Flow",
            picture:
              "/media/assets/irrigation-system-health/icons-all-go-with-the-flow.png"
          };
      }
    },
    activeLang() {
      return i18nService.getActiveLanguage();
    }
  }
};
</script>

<style scoped>
.canEnlargeImage img:after {
}
</style>
